import { userConstants } from '../_constants';
import { userService } from '../_services';
import { history } from '../_helpers';
import { store } from './../_helpers';

export const userActions = {
  login,
  logout,
  getAll,
  forgetPassword,
  changePassword
};

function login(username, password) {
  // return dispatch => {
  // dispatch(request({ username }));
  store.dispatch(request({ username }));
  return userService.login(username, password).then(
    user => {
      // dispatch(success(user));
      history.push('/');
      if (user.rCode === 100) {
        store.dispatch(success(user.results[0]));
        return success(user.results[0]);
      } else {
        // console.log("details failier", user)
        return failure(user);
      }
    },
    error => {
      console.log('details fail');
      store.dispatch(failure(error));
      return failure(error);
    }
  );

  // };

  function request(user) {
    return { type: userConstants.LOGIN_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }
}

function logout() {
  userService.logout();
  return { type: userConstants.LOGOUT };
}

function getAll() {
  return dispatch => {
    dispatch(request());

    userService.getAll().then(
      users => dispatch(success(users)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: userConstants.GETALL_REQUEST };
  }
  function success(users) {
    return { type: userConstants.GETALL_SUCCESS, users };
  }
  function failure(error) {
    return { type: userConstants.GETALL_FAILURE, error };
  }
}

function forgetPassword(email) {
  return userService.forgetPassword(email).then(res => {
    return res;
  });
}

function changePassword(key) {
  return userService.changePassword(key).then(res => {
    return res;
  });
}
